import { PHASE } from "./constants.ts";

/** Shared by Daily Schedule and the worker: only the currently controlled club. */
export const canPlayManual3D = ({ homeTid, awayTid, userTid, phase, spectator = false }: {
 homeTid: number; awayTid: number; userTid: number; phase: number; spectator?: boolean;
}) => !spectator && homeTid >= 0 && awayTid >= 0 && userTid >= 0 &&
 (phase === PHASE.REGULAR_SEASON || phase === PHASE.AFTER_TRADE_DEADLINE || phase === PHASE.PLAYOFFS) &&
 (homeTid === userTid || awayTid === userTid);
